// Real APIs
export const SYSTEM_STATUS_API = `https://SECRET.execute-api.us-east-1.amazonaws.com/default/getMonitorResults`;

// // Dummy APIs
// export const SYSTEM_STATUS_API = `https://run.mocky.io/v3/806ee366-1684-475b-aec3-1bf2094c8d35`;
// // secret token: system-status-secret-token-yueteng